import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { secureBusinessKey } from "../api/apiEndpoints";

export const updateReservation = createAsyncThunk(
  "reservation/updateReservation",
  async (
    { reservationIds, serviceIds, parentReservationId, orderID },
    { rejectWithValue }
  ) => {
    try {
      const handleReservationOptions = {
        url: `${process.env.REACT_APP_ECOMMERCE_BASE_URL}/api/v2/update_reservation_id/${orderID}`,
        method: "PUT",
        headers: {
          "Accept-Language": "en",
          "secure-business-key": secureBusinessKey,
        },
        data: {
          reservation_id: reservationIds,
          service_id: serviceIds,
          parent_reservation_id: parentReservationId,
        },
      };

      const { data } = await axios.request(handleReservationOptions);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const reservationSlice = createSlice({
  name: "reservation",
  initialState: {
    reservationResponse: null,
    isLoading: false,
    isError: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateReservation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateReservation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reservationResponse = action.payload;
      })
      .addCase(updateReservation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload || action.error.message;
      });
  },
});

export default reservationSlice.reducer;

export const reservationReducer = reservationSlice.reducer;
